import { t } from "@lingui/core/macro";
import { assertNever } from "@regrello/core-utils";
import { UserAccessLevel, type UserFields } from "@regrello/graphql-api";

export function getUserAvatarScope(user: Pick<UserFields, "accessLevel">): "internal" | "external" | "limited" {
  switch (user.accessLevel) {
    case UserAccessLevel.INTERNAL:
      return "internal";
    case UserAccessLevel.EXTERNAL:
      return "external";
    case UserAccessLevel.LIMITED:
      return "limited";
    default:
      assertNever(user.accessLevel);
  }
}

export function getUserAccessLevelDisplayString(user: Partial<Pick<UserFields, "accessLevel">>): string {
  switch (user.accessLevel) {
    case undefined:
      return t`No access`;
    case UserAccessLevel.INTERNAL:
      return t`Internal`;
    case UserAccessLevel.EXTERNAL:
      return t`External`;
    case UserAccessLevel.LIMITED:
      return t`Limited`;
    default:
      assertNever(user.accessLevel);
  }
}

export function getUserAccessLevelFromDisplayString(displayString: string): UserAccessLevel | undefined {
  switch (displayString) {
    case t`No access`:
      return undefined;
    case t`Internal`:
      return UserAccessLevel.INTERNAL;
    case t`External`:
      return UserAccessLevel.EXTERNAL;
    case t`Limited`:
      return UserAccessLevel.LIMITED;
    default:
      return undefined;
  }
}
